// import "../Factor/Factor.scss";

import {ReactTabulator} from "react-tabulator";
import axios from "axios";
import {forwardRef, useContext, useEffect, useRef, useState} from "react";
import Form, {checkForm} from "../Form";
import BarcodeLabel from "../BarcodeLabel";
import {toast} from "react-toastify";
import {PrintDataContext} from "../../Pages";


import ReactToPrint, {PrintContextConsumer} from "react-to-print";

import ComponentToPrintBarcodeInEditSection from "../Form/ComponentToPrintBarcodeInEditSection"
// const ComponentToPrintBarcodeInEditSection = forwardRef((props, refToPrintBarcode) => {
//     const {submitResponse} = props;
//     console.log(props);
//
//     return (
//         <div ref={refToPrintBarcode}>
//             <BarcodeLabel
//                 barcodeCount={submitResponse !== undefined ? submitResponse.barcodeCount : 1}
//                 barcodeLength={submitResponse !== undefined ? submitResponse.barcodeLength : 33}
//                 barcodeWidth={submitResponse !== undefined ? submitResponse.barcodeWidth : 50}
//                 paperWidth={submitResponse !== undefined ? submitResponse.paperWidth : 55}
//                 productCode={submitResponse !== undefined ? submitResponse.productCode : "1000"}
//                 productColor={submitResponse !== undefined ? submitResponse.productColor : "رنگ"}
//                 productName={submitResponse !== undefined ? submitResponse.productName : "نام محصول"}
//                 productPrice={submitResponse !== undefined ? submitResponse.productPrice : "قیمت"}
//                 productSize={submitResponse !== undefined ? submitResponse.productSize : "سایز"}
//                 productFont={submitResponse !== undefined ? submitResponse.productFont : "14"}
//                 displayProductCodeValue={submitResponse !== undefined ? submitResponse.displayProductCodeValue : true}
//             />
//         </div>
//     )
// });

const FastPrint = () => {

  // const [idToSendBack, setIdToSendBack] = useState(null);
  const [typeToSendBack, setTypeToSendBack] = useState(null);
  const [numberOfBarcodesToPrint, setNumberOfBarcodesToPrint] = useState("");

  function submitAndPrint() {
    // setIdToSendBack(searchIdRef.current.value);
    if (typeToSendBack) {
      if (searchData != "") {
        if (numberOfBarcodesToPrint === "" || parseInt(numberOfBarcodesToPrint) <= 0) {
          if (parseInt(numberOfBarcodesToPrint) === 0) {
            toast.error("تعداد بارکد را صحیح وارد کنید.")
          } else {
            toast.error("لطفا تعداد بارکد را وارد کنید.")
          }
          return
        }
        // const temp = [`${searchData}`]
        // const data={id:temp, type:typeToSendBack}
        //
        const data = new FormData();
        // data.append('id', '[2812]');
        data.append('id', `[${searchData}]`);
        data.append('type', 'id');
        //
        const factorSubmitRequest =
          axios({
            method: 'post',
            url: `${localStorage.getItem("apiUrl")}/barcode/`,
            // params: {id: temp, type: typeToSendBack},
            data: data,
            headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
          })
            .then((response) => {
              console.log(response.data);
              response.data[0].barcodeCountUserInput = parseInt(numberOfBarcodesToPrint);
              console.log(response.data);
              setSubmitResponse(response.data[0])
            })

        toast.promise(factorSubmitRequest, {
          pending: "در حال دریافت بارکد ",
          success: "بارکد با موفقیت دریافت شد.",
          error: "دریافت بارکد  با مشکل مواجه شد",
        });
      } else {
        toast.error(" لطفا کد کالا رو وارد کنید!")
      }
    } else {
      toast.error("بر اساس کد کالا یا فروشگاه؟");
    }


  }

  const [submitResponse, setSubmitResponse] = useState(undefined);
  // useEffect(() => {
  // }, [submitResponse])

  const [searchData, setSearchData] = useState("");
  const [searchDataList, setSearchDataList] = useState([]);

  function searchParamOnChangeHandlerFunction(e) {
    setTypeToSendBack(e.target.value);
    setSearchData("");
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/barcode/`,
      params: {list: e.target.value},
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => setSearchDataList(response.data))
      .catch((error) => console.error(error));
  }


  const refToPrintBarcode = useRef();
  // const height= submitResponse !== undefined ? '150px' : '300px';
  const heightStyle = `
 .plzSetCorrectHeight{
    height: ${submitResponse === undefined ? 'auto' : submitResponse.barcodeLength + 4 + "mm"};
    display: flex;
    justify-content: space-around;
    flex-flow: column;
    align-items: center;
    margin: 0 auto;
    width: 90%;
    
    }
 `;
  return (
    <>
      <style> {heightStyle}</style>
      <div className={"inDashboardCssFastPrint  d-flex  justify-content-around"}>
        <div className="search-object text-center" style={{'width': '90%'}}>
          <div className={"plzSetCorrectHeight"}>
            <select
              className="form-select"
              onChange={searchParamOnChangeHandlerFunction}
              defaultValue="id">
              <option value="id" selected disabled hidden>انتخاب کنید</option>
              <option value="id">بر اساس کد کالا</option>
              <option value="internetId">بر اساس کد کالای فروشگاه</option>
            </select>

            <input
              type="search"
              className="form-control "
              placeholder="جستجو"
              name="search"
              list="factorPageProductList"
              autoComplete="off"
              value={searchData}
              onChange={(e) => {
                setSearchData(e.target.value);

              }}
            />
            <datalist id="factorPageProductList">
              {searchDataList.map((value, index) => (
                <option key={index} value={value}/>
              ))}
            </datalist>
            <input
              type="number"
              className="form-control"
              placeholder="تعداد بارکد"
              onChange={(event) => {
                let temp = event.target.value
                if (temp < 0) {
                  temp = 0;
                }
                setNumberOfBarcodesToPrint(temp)
              }}
              value={numberOfBarcodesToPrint}
            />
          </div>

          <div className="text-center">
            <br/>
            <button className="btnCustom btnSubmit"
                    onClick={submitAndPrint}
            >
              نمایش بارکد
            </button>
          </div>

        </div>
        <div className={submitResponse === undefined ? "d-none" : "d-block"}>
          <div className={"border border-dark rounded-3"}
               style={{
                 'margin': ' 0 auto', 'width': 'max-content',
                 "maxHeight": '22mm',
                 "minWidth": submitResponse !== undefined ? `${submitResponse.barcodeWidth}mm`: "0",
                 "overflow": "hidden",
               }}>
            <ComponentToPrintBarcodeInEditSection submitResponse={submitResponse}
                                                  ref={refToPrintBarcode}/>
          </div>
          <br/>
          <div className={"text-center"}>
            <ReactToPrint content={() => refToPrintBarcode.current}>
              <PrintContextConsumer>
                {({handlePrint}) => (
                  <button
                    disabled={submitResponse === undefined}
                    className="btnCustom btnSubmit"
                    onClick={handlePrint}>پرینت بارکد</button>
                )}
              </PrintContextConsumer>
            </ReactToPrint>
          </div>
        </div>
      </div>
    </>
  );
}

export default FastPrint;